<!--
  时间：2024年10月09日 10:13:00
-->
<template>
  <div class="h40 fs14" v-if="show">
    <div class="header_fix flex-box" ref="head_fix">
      <div class="flex-grow-1">
        <!-- <div class="flex-box cursor" v-if="isLogin">
          <img src="../assets/static/icon/jj_head_address.png" class="ico20" alt="" />
          <div class="plr5 col4b">{{ userInfo.company_name }}</div>
          <img src="../assets/static/icon/jj_head_arrow_down.png" class="ico16" alt="" />
        </div> -->
      </div>
      <div class="flex-box">
        <template v-if="!isLogin">
          <div class="col4b cursor" @click="toLogin">你好，<span class="col3d">请登录</span></div>
        </template>
        <template v-else>
          <div class="flex-box user_name" :class="showDetail ? 'choose' : ''"  @mouseenter="showDetail = true" @mouseleave="showDetail=false">
            <img :src="userInfo.avatar || '../assets/static/icon/jj_head_user.png'" class="ico20 circle cursor"
            alt="" />
            <div class="plr5 col4b cursor" >{{ userInfo?.company_name }}</div>
            <img src="../assets/static/icon/jj_head_arrow_down.png" class="ico16 cursor" alt=""
               />
            <div class="user_info" v-if="showDetail">
              <div class="plr16">
                <div class="user_name_info flex-box cursor" @click="toInfo">
                  <img :src="userInfo.avatar || '../assets/static/icon/jj_profile_normal.png'" class="user_name_info_img" alt="" />
                  <div class="plr14 m-ellipsis flex-grow-1 col4b">{{ userInfo.company_name || '' }}</div>
                  <img :src="userInfo.vip?.image_text" class="vip" alt="" />
                </div>
              </div>
              <div>
                <router-link class="sub_tab" @click="showDetail = false" to="/IncomeDetail">积分收益</router-link>
                <router-link class="sub_tab" @click="showDetail = false" to="/Vip">会员等级</router-link>
                <router-link class="sub_tab" @click="showDetail = false" to="/SubManage"  v-if="userInfo && userInfo.institution_type == 1">机构信息</router-link>
                <router-link class="sub_tab" @click="showDetail = false" to="/Collection">我的收藏</router-link>
                <router-link class="sub_tab" @click="showDetail = false" to="/ServiceTerm">服务条款</router-link>
                <router-link class="sub_tab" @click="showDetail = false" to="/HelpCenter">帮助中心</router-link>
              </div>
              <div class="btn_exit cursor" @click="logout()">退出登录</div>
            </div>
          </div>
        </template>
        <router-link class="ml52 col4b" to="/Order">我的订单</router-link>
        <router-link class="ml52 col4b" to="/SubManage" v-if="userInfo && userInfo.institution_type == 1">机构中心</router-link>
        <router-link class="ml52 col4b" to="/ServiceTerm">服务条款</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: ["value", "show", "userInfo"],
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      showDetail: false,
      isLogin: false,
      userInfo: {},
    };
  },
  // 计算属性
  computed() { },
  // 侦听器
  watch: {},
  created() { },
  mounted() {
    if (this.$cookies.get("token")) {
      this.isLogin = true;
      this.userInfo = this.$cookies.get("userinfo");
    }
    this.$bus.on("refreshLogin", () => {
      this.isLogin = true;
      this.userInfo = this.$cookies.get("userinfo");
    });
  },
  beforeUnmount() {
    this.$bus.off('refreshLogin');
  },
  // 组件方法
  methods: {
    toLogin() {
      this.$router.push("/Login");
    },
    toInfo() {
      this.$router.push("/BaseInfo");
      this.showDetail = false;
    },
    logout() {
      this.showDetail = false;
      this.$cookies.remove("token");
      this.$cookies.remove("userinfo");
      this.isLogin = false;
      if (this.$route.path != '/') {
        this.$router.push('/');
      } else {
        this.$bus.emit('refreshPage');
      }
    },
  },
};
</script>


<style lang="less" scoped>
.h40 {
  height: 40px;
}

.ico20.circle {
  border-radius: 50%;
  width: 20px;
  height: 20px;
}

.header_fix {
  width: 100%;
  height: 40px;
  background: #ffffff;
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  right: 0;
  padding: 0 100px;
}

.ico20 {
  width: 20px;
  height: auto;
}

.col4b {
  color: #4b4b4b;
}

.ico16 {
  width: 10px;
  height: auto;
}

.col3d {
  color: #3d7efe;
}

.ml52 {
  margin-left: 52px;
}

.user_name {
  height: 40px;
  position: relative;
  padding: 0 16px;
  border-left: 1px solid #fff;
    border-right: 1px solid #fff;
  &.choose {
    border-left: 1px solid #d0d0d0;
    border-right: 1px solid #d0d0d0;
  }

  .user_info {
    width: 390px;
    border: 1px solid #d0d0d0;
    position: absolute;
    top: 40px;
    left: -1px;
    background: #ffffff;
    z-index: 100;
    padding-bottom: 30px;
  }

  &_info {
    border-bottom: 1px solid #e6e6e6;
    height: 86px;

    &_img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      object-fit: cover;
    }
  }
}

.plr14 {
  padding-left: 14px;
  padding-right: 14px;
}

.vip {
  width: 69px;
  height: auto;
}

.sub_tab {
  margin-top: 22px;
  width: 33.3%;
  text-align: center;
  display: inline-block;
  vertical-align: top;
  color: #272727;
}

.btn_exit {
  width: 262px;
  height: 40px;
  line-height: 38px;
  text-align: center;
  color: #777777;
  margin-left: auto;
  margin-right: auto;
  margin-top: 35px;
  border-radius: 25px;
  border: 1px solid #979797;
}
</style>
